import React, { useState, useEffect } from "react";
import { getRequest, postRequest } from "../Common/Utils.js";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import Swal from "sweetalert2/dist/sweetalert2.js";

import BootstrapTable from "react-bootstrap-table-next";
import { Link, NavLink } from "react-router-dom";
import ReactPaginate from "react-paginate";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Spinner,
  Badge,
  UncontrolledTooltip,
  Modal,
  Button,
} from "reactstrap";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";

const TableComponent = ({ selectRow }) => {
  const [Productdata, setProductdata] = useState([]);
  const [loader, setLoader] = useState(false);
  const [sort, setsort] = React.useState("name");
  const [currentFPage, setCurrentFPage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(0);
  const [sizePerPageOrg, setSizePerPage] = useState(10);
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    ProductManagment();
  }, [currentPage]);

  useEffect(() => {
    ProductManagment();
  }, [sizePerPageOrg, sort]);

  const handleTableChange = (type, { page, sizePerPage, searchText }) => {
    if (type === "pagination") {
      if (page != currentPage) {
        setCurrentPage(page);
        console.log("page", page);
      }
    }

    console.log("type", type);

    if (type === "search") {
      console.log("searchText", searchText);
    }
  };

  const defaultSorted = [
    {
      dataField: "_id",
      order: "asc",
    },
  ];

  function ImgLogoFormatter(cellContent, row) {
    return (
      <>
        <img src={row?.images[0]} alt="img" width={"50px"} />
      </>
    );
  }



  function SNoFormatter(cellContent, row, i) {
    return <>{i + 1}</>;
  }

  const columns = [
    {
      text: "S.NO",
      formatter: SNoFormatter,
      sort: false,
    },
    {
      dataField: "name",
      text: "Product Name",
      sort: false,
    },

    {
      // dataField: "images",
      text: "Product images",
      formatter: ImgLogoFormatter,
      sort: false,
    },

    {
      dataField: "select",
      text: "Select",
      formatter: iconFormatter,
      sort: false,
    },
  ];

  const handleChange = (event) => {
    console.log("page value ", event.target.value);
    setSizePerPage(event.target.value);
  };
  const handlesorting = (event) => {
    setsort(event.target.value);
    console.log("sorting  value ", event.target.value);
  };
  const handleReload = () => {
    window.location.reload();
  };
  function iconFormatter(cellContent, row) {
    return (
      <React.Fragment>
        <div className="d-flex">
          <button
            type="button"
            className="btn btn-danger"
            onClick={() => selectRow(row, row._id, row.title)}
          >
            <i class="fal fa-plus  fs-5"></i>
          </button>
        </div>
      </React.Fragment>
    );
  }

  const limit = 10;

  const ProductManagment = async (page = 0) => {
    console.log(currentPage);
    setLoader(true);
    const payload = {
      limit: sizePerPageOrg,
      page: currentPage,
      sortField: sort,
      sortOrder: "asc",
    };

    if (searchText) {
      payload.search = searchText;
    }

    const response = await postRequest(`product/product-list-admin`, payload);
    const data = response?.data;

    //console.log("data", data, response)

    setTotalPage(data.total);
    setCurrentFPage(data.currentPage);
    setProductdata(data.list);
    setLoader(false);
  };

  return (
    <>
      <React.Fragment>
        <Row>
          <Col className="col-12">
            <Card>
              {loader ? (
                <CardBody style={{ height: "100px" }}>
                  <Spinner
                    color="info"
                    style={{
                      height: "4rem",
                      width: "4rem",
                      position: "absolute",
                      left: "50%",
                    }}
                  >
                    Loading...
                  </Spinner>
                </CardBody>
              ) : (
                <CardBody className="table-shorting">
                  {
                    <PaginationProvider
                      pagination={paginationFactory({
                        page: currentFPage,
                        sizePerPage: sizePerPageOrg,
                        totalSize: totalPage,
                        custom: true,
                      })}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <>
                          <ToolkitProvider
                            keyField="_id"
                            data={Productdata}
                            columns={columns}
                          >
                            {(props) => (
                              <Row>
                                <Col className="col-lg-12 d-flex mb-3">
                                  <div className="d-flex w-50">
                                    <label className="mb-0 text-label">
                                      Page Size
                                    </label>

                                    <select
                                      value={sizePerPageOrg}
                                      onChange={handleChange}
                                      className="form-select"
                                      style={{ width: "10%" }}
                                    >
                                      <option value="10">10</option>
                                      <option value="20">20</option>
                                      <option value="50">50</option>
                                    </select>
                                  </div>
                                  <div className="w-50 text-end">
                                    <div className="d-flex g-3 justify-content-end">
                                      <input
                                        type="search"
                                        placeholder="Search"
                                        value={searchText}
                                        class="form-control"
                                        onChange={(e) =>
                                          setSearchText(e.target.value)
                                        }
                                        style={{ width: "30%" }}
                                      />
                                      <button
                                        onClick={() => {
                                          ProductManagment();
                                        }}
                                        type="button"
                                        className="btn btn-primary mx-2"
                                      >
                                        Search
                                      </button>
                                    </div>
                                  </div>
                                </Col>

                                <Col className="col-lg-12 text-end">
                                  <BootstrapTable
                                    onTableChange={handleTableChange}
                                    remote={true}
                                    classes="table-striped"
                                    {...props.baseProps}
                                    {...paginationTableProps}
                                  />
                                </Col>
                              </Row>
                            )}
                          </ToolkitProvider>

                          <Row>
                            <Col className="col-lg-12 text-end">
                              <div className="text-md-right">
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </div>
                            </Col>
                          </Row>
                        </>
                      )}
                    </PaginationProvider>
                  }
                </CardBody>
              )}
            </Card>
          </Col>
        </Row>
      </React.Fragment>
    </>
  );
};


const BuyProduct = ({ data, show, closeModal, selectRow }) => {
  
  const [minimumQuantity, setMinimumQuantity] = useState(data?.minimumQuantity || 1);
  const [quantity, setQuantity] = useState(data?.minimumQuantity || 1);

  // Update state when `data.minimumQuantity` changes
  useEffect(() => {
    if (data?.minimumQuantity) {
      setMinimumQuantity(data.minimumQuantity);
      setQuantity(data.minimumQuantity);
    }
  }, [data?.minimumQuantity]);
  console.log(data?.minimumQuantity);

  const handleDecrement = () => {
    if (quantity > minimumQuantity) {
      setQuantity(quantity - 1);
    } else {
      Swal.fire({
        icon: 'warning',
        title: 'Minimum Quantity',
        text: `The quantity cannot be less than ${minimumQuantity}.`,
        confirmButtonText: 'OK',
        timer: 2000,
      });
    }
  };

  const handleIncrement = () => {
    setQuantity(quantity + 1);
  };

  const handleChange = (e) => {
    let newQuantity = Number(e.target.value);
    if (newQuantity < minimumQuantity) {
      Swal.fire({
        icon: 'warning',
        title: 'Minimum Quantity',
        text: `The quantity cannot be less than ${minimumQuantity}.`,
        confirmButtonText: 'OK',
        timer: 2000,
      });
      newQuantity = minimumQuantity;
    }
    setQuantity(newQuantity);
  };



  const buyProduct = async (quantity, productid, warehouseId, manufactureId) => {
    try {
      const payload = {
        products: [
          {
            productId: productid,
            quantity: quantity,
          },
        ],
        manufactureId: manufactureId,
        warehouseId: '66bc3d46609c9777486b1e6b',
      };
      const res = await postRequest('order/create-manufacture-order', payload);
      if (res.status) {
        closeModal();
        setMinimumQuantity(data?.minimumQuantity);
        setQuantity(data?.minimumQuantity);
        Swal.fire({
          icon: 'success',
          title: 'Success',
          text: 'The order has been successfully sent to the manufacturer.',
          confirmButtonText: 'OK',
          timer: 3000,
        });
      }
    } catch (error) {
      console.log('Please try again later.');
    }
  };

  return (
    <Modal
      isOpen={show}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered={true}
    >
      <div className="modal-header">
        <h5 className="modal-title mt-0" id="myLargeModalLabel">
          Buy Product
        </h5>
        <button
          onClick={() => {
            closeModal();
          }}
          type="button"
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">
        <div className="product-item">
          <div className="image-product">
            <img src={data?.images?.[0]} alt={data?.images?.[0]} />
          </div>
          <div className="product-info" style={{ width: '50%'}}>

            <h5>{data?.name}</h5>

            <div className="manufacturedetail">
              <div className="logo-manufacturedetail"> <img src={data?.manufacturerDetail?.logo} /></div>
              {data?.manufacturerDetail?.companyName} <br />
              {data?.manufacturerDetail?.address}
            </div>

            <div className="cart_qty mb-2">
              <div className="input-group quantity-prod">
                <button
                  type="button"
                  className="btn qty-left-minus"
                  onClick={handleDecrement}
                >
                  <i className="fa fa-minus ms-0" />
                </button>
                <input
                  className="form-control input-number qty-input"
                  type="number"
                  onChange={handleChange}
                  value={quantity} // Make the input value dynamic
                />
                <button
                  type="button"
                  className="btn qty-right-plus"
                  onClick={handleIncrement}
                >
                  <i className="fa fa-plus ms-0" />
                </button>
              </div>
            </div>


          </div>
        </div>

        {/* <TableComponent selectRow={selectRow} /> */}
      </div>
      <div className="modal-footer">
        <button type="button" onClick={() => {
          closeModal();
        }} className="btn btn-danger">Cancel</button>
        <button type="button" onClick={() => buyProduct(quantity, data?._id, data?.warehouseId, data?.manufacturerDetail?._id)} className="btn btn-info">Confirm Order</button>
      </div>
    </Modal>
  );
};

export default BuyProduct;
